// 按页面划分
export default {
  // 公共页面
  common: {
    title:"トラフィックモール",
    pull_refresh: 'スワイプして更新',
    release_refresh: 'リリースして更新',
    refresh_loading: '更新中...',
    footer_text: 'サービスは Ucloudlink（NASDAQ: UCL）によって提供されています'
  },
  home: {
    input_placeholder: '海外用プランを検索する',
    my_flow: '購入済みプラン',
    charge_code: 'クーポンコード',
    coupons:'クーポン',
    local_package: '国内用プラン',
    more: 'その他',
    popular_destination: '国／地域',
    buy_now: '今すぐ購入',
    package_useing: '有効',
    unused: '無効',
    download_app: 'アプリをダウンロードしてください',
    enter_the_mall_list: 'モールに入る',
    no_data: 'データがありません',
    no_data_available: 'データなし',
    copy_success: 'コピーに成功しました',
    copy_fail: 'コピーに失敗しました',
    meritsTitle: 'メリットは何ですか？',
    merits1: 'SIM 不要 & 月額料金なし',
    merits2: 'トップ 2-3 オペレーター統合、ネットワーク自動切り替え',
    go_buy: '購入する',
    instant_savings: 'お得',
    expires_in: '有効期限まで',
    download_app_tips: "アプリをダウンロードして特典と体験を！"
  },
  packages: {
    sub_title: {
      us: 'グアムとサイパンを除く',
      it: '适用梵蒂冈、圣马力诺',
      va: '适用意大利、圣马力诺',
      sm: '适用意大利、梵蒂冈',
      ma: '适用西撒哈拉',
      eh: '适用摩洛哥',
      ch: '适用列支敦士登',
      li: '适用瑞士',
      fr: '适用摩纳哥',
      mc: '适用法国',
      fi: '适用奥兰群岛',
      ax: '适用芬兰',
      gu: '适用塞班岛',
      mp: '适用关岛'
    },
    unlimited_packages: '無制限のデータプラン',
    normal_packages: 'データプラン',
    multi_region_packages: '複数エリア',
    regional_data: '地域データ',
    high_speed_text: 'まで高速通信',
    infiniteFlow: "使い放題データ",
    unLimitData: '無制限',
    high_speed_text_year: 'まで高速通信/月',
    package_list: 'プランリスト',
    special_offer: 'セール ',
    first_month: '1 ヶ月',
    periodUnit: {
      day: '日間',
      month: '月',
      hour: '時間',
      year: '年',
    },
    periodUnits: {
      day: '日間',
      month: 'か月',
      hour: '時間',
      year: '年',
    },
    periodUnitSimp: {
      day: '日間',
      month: '月',
      hour: '時間',
      year: '年'
    },
    periodUnitMonthly:'月額',
    periodUnitsSimp: {
      day: '日間',
      month: 'か月',
      hour: '時間',
      year: '年'
    },
    unlimited_good_name: {
      day: '1日プラン',
      month: '月額プラン',
      year: '年額プラン'
    },
    continuousMonth : "毎月",
    continuousDay : "毎日",
    continuousYear:"毎年",
    day_invalid: '当日有効',
    month_invalid: '当月有効',
    immediate_valid: '即時有効',
    tomorrow_day_valid: '翌日有効',
    tomorrow_month_valid: '翌月有効',

    // detail page
    detail: {
      cell_flow: 'データ容量',
      cell_period: '有効期限',
      buy_quantity: '購入数',
      use_area: 'サービスエリア',
      use_intro: '使用上の注意',
      buy_btn: '購入',
      pay: '支払う',
      buy_tips: '%@packageNameプランをご利用中です。このプランを購入しますか？',
      haveOrderTips: "支払い待ち注文を作成しました。確認をクリックしてマイデータページで確認！"
    },

    // confirm page
    confirm: {
      title: '支払確認',
      real_pay_amount: 'お支払い金額',
      online_payment: 'オンライン支払',
      create_order_error: '設定できませんでした'
    }
  },

  pay: {
    // result page
    result: {
      loading_order_status: '購入情報を確認しています。しばらくお待ちください。',
      buy_success: '支払完了',
      buy_pending: '支払い保留',
      buy_pending_tip: 'お支払い内容を確認しています。10分以内に完了できない場合は、カスタマーサービスにお問い合わせください。',
      get_payment_info_fail: '支払い情報を取得できませんでした',
      cell_package: 'パッケージ名',
      cell_buy_amount: '支払い金額',
      cell_real_amount: 'お支払い金額',
      go_to_order_btn: '購入履歴の確認',
      back_home: 'ホーム画面に戻る',
      back_mall: 'モールに戻ります',
      ordersn_empty: 'エラーが発生しました',
      order_search_error: 'エラーが発生しました',
      goodsName:'製品名'
    },

    //fail page
    fail: {
      payment_fail: '購入できませんでした',
      //payment_fail_desc: '请返回商品页面，重新购买',
      back_home: 'ホーム画面に戻る'
    },
  },

  order: {
    state: {
      inUse: '使用中',
      isFirst: '優先',
      toFirst: '優先にする',
    },
    periodUnits: {
      minute: '分',
      hour: '時間',
      day: '日間',
      month: 'か月',
    },
    useIntro: {
      tip1: '無制限のデータパッケージは、標準のデータパッケージよりも優先されます。',
      tip2: '使用の優先度は、同じタイプのパッケージの購入日に基づいています。購入日が最も早いパッケージが最優先で使用され、単一地域のパッケージの優先度は地域のパッケージよりも高くなります。',
      tip3: '同じタイプのデータパッケージの優先順位は手動で調整することもできます。'
    },
    myFlow: '購入済みプラン',
    remainingFlow: 'データ残量',
    remainingTime: '残りの有効期限',
    remainingHighFlow: '高速通信の残量',
    validPeriod: '有効期限',
    noneFlow: 'データプランがありません',
    noneFlowTip: 'データプランを購入してください',
    buyPackFlow: 'パッケージを購入',
    checkInvalidFlow: '期限切れのデータを確認',
    orderList: {
      "title": "私の命令",
      "amount_paid": "合計",
      "device": "所有デバイス",
      "order_details": "注文の詳細",
      "total_amont": "小計",
      "orderSN": "注文番号",
      "createTime": "作成時間",
      "cancelTime": "閉店時間",
      "payTime": "注文時間",
      "unsubTime": "キャンセル時間",
      "payMethod": "支払方法",
      "thirdSN": "取引番号",
      "delete": "消去",
      "cancel": "注文をキャンセルする",
      "unsub": "返金",
      "goto_cancel": "注文をキャンセルしますか?",
      "goto_unsubscribe": "注文の購読を解除しますか?",
      "delete_Tips": "削除後は注文を再開できませんので、アフターサービスの問題には対応できません。削除してもよろしいですか?",
      "status_success": "完了しました",
      "status_pending": "未払い",
      "status_cancel": "閉店",
      "status_unsub": "キャンセル",
      "payMethod_stripe": "クレジットカード"
    },
  },
  registerlogin: {
    create_account_tip:"アカウントを作成し、排他的なエクスペリエンスを開始します",
    select_country_tip: "デバイスは国/地域を使用します",
    email_name: "郵便",
    phone_name: "電話",
    email_address: "電子メールアドレス",
    password: "パスワード",
    country: "国",
    select_country: "国を選択してください",
    cancel: "キャンセル",
    confirm: "もちろん",
    please_enter: "6-20文字を入力してください（文字、数字、またはシンボルの組み合わせ）",
    select_country_tips: "国の選択は、地元のパッケージを表示するためのものです。登録後に変更することはできません。確認してください！",
    global_roaming: "国際ドメインコード",
    phone_number: "電話番号",
    agree: "同意する",
    user_agreement: "ユーザー契約",
    and: "そして",
    privacy_policy: "プライバシーポリシー",
    register_login: "サインアップまたはログインします",
    login_error: "ログインの数が多すぎるので、後でもう一度やり直してください！",
    register_error: "登録数が多すぎるので、後でもう一度やり直してください！",
    forgot_pwd: "パスワードを忘れた",
    app_tips: "ダウンロードした後、このアカウントでアプリにログインして、より多くの機能にアクセスします。",
    download_app: "アプリをダウンロードしてください",
    rememberPwd:"パスワードを記憶する",
    third_login: "で続ける",
    agreement_tips: "ユーザー契約とプライバシーポリシーのボックスにチェックを入れてください",
    selectCountry_tips: "登録された国は、以下の支払い方法と通貨に直接影響しますので、必要に応じて選択してください。",
    login_error_cancel: "ユーザーがログインをキャンセルしました",
    login_error_auth: "ブラウザーの設定からポップアップを許可してください",
    device_tips: "機器は啟動待ちです。24 時間以内に處理いたします。"
  },
  forgotPwd: {
    forgot_pwd: "パスワードを忘れた",
    email_address: "電子メールアドレス",
    next: "次",
    email_has_been_sent: "%@emailにメールを送信しました。リンクをクリックして、手順に従ってパスワードを取得してください。",
    have_retrieved_it: "私はそれを見つけました",
    unable_to_receive_email: "メールを受け取れませんか？スパムと削除されたメールディレクトリの下に%@emailから電子メールがあるかどうかを確認してください",
    or: "または",
    resend: "再送信",
    global_roaming: "国際ドメインコード",
    phone_number: "電話番号",
    verification_code_has_been_sent: "確認コードを次のように送信しました。",
    verification_code: "検証コード",
    no_verification_code_received: "確認コードを受け取りませんでしたか？",
    please_enter: "6-20文字を入力してください（文字、数字、またはシンボルの組み合わせ）",
    reset_password: "パスワードをリセットします",
    reset_successful: "正常にリセットします"
  },
  coupons: {
    coupons_name: "クーポン",
    no_coupons: "まだクーポンはありません",
    no_data: "まだデータはありません",
    applicable_to_the_following: "クーポンは、次のデータパッケージに適しています"
  },
  digital: {
    title: "デバイスSN",
    purchased: "私の購入",
    viewAll: "もっと",
    skinStore: "製品ストア",
    completed: "購入した",
    goBuy: "買う",
    order: {
        title: "購入した注文"
    },
    detail: {
        describe: "説明"
    }
  },
  viewPL: {
    other: 'その他'
  },
  invalidFlow: {
    stateName: 'ステータス',
    state: {
      NOT_ACTIVATED: "未激活",
      IN_USING: "使用可能",
      USE_END: "使い切りました",
      EXPIRE: "期限が切れました",
      TRANSFER: "已轉移",
      UNSUBSCRIBE: "キャンセル",
      VALID: "有効",
      INVALID: "無効",
      EXCHANGE_POINTS: "兌換積分"
    },
    noneFlow: '効なデータパッケージはありません',
    pageName: 'データ詳細'
  },
  CountryGroup: {
    title: "国／地域",
    placeholder: "海外用プランを検索する",
    clear: "クリア",
    history: "履歴"
  },
  PromotionCode: {
    verification: {
      title: 'クーポンコード',
      minititle:'チャージコード',
      input: 'チャージコードを入力してください。',
      explain: 'スキャンアイコンをタップしてQRコードをスキャンしてください。またはクーポンコードを入力してください。(コードは大文字と小文字が区別されます)',
      submit: '確認',
      exchange: '取得',
      cancel: 'キャンセル',
      ErrorCode: 'チャージコードエラー',
      Inquiry: "を交換しますか？",
    },
    recharge_success: {
      package: 'データプラン/パッケージ',
      content: '引換できました',
      back: 'データプラン購入画面に戻る',
      view_packets: '購入履歴の確認'
    }
  },
  flowDetail: {
    title: 'データ詳細',
    flow: 'データ容量',
    validTime: '開始日',
    invalidTime: '有効期限',
    coverage: 'サービスエリア',
    useIntro: '使用上の注意',
    purchaseTime: '購入時間',
    subtotal: '支払い金額',
    status: 'ステータス',
    cancel: 'キャンセル',
    buyAgain: '再購入',
    validity: '有効期限',
    tip: 'お知らせ',
    cancelTip: 'キャンセルしますか？',
    dataLeft: 'データ残量'
  },
  netError: {
    try_again: 'もう一度実行する',
    net_error: 'ネットワークがありません。',
    try_again_desc: 'ネットワーク設定をご確認いただき、再度お試しください'
  },
  loadFail: {
    try_again: 'もう一度実行する',
    load_fail: '読み込みに失敗',
    load_fail_desc: 'データの読み込みに失敗しました。再度お試しください',
    IMEI_Not_Exist:'IMEI存在しません,右の入り口から入ってみてください',
    Project_Not_Exist:'異常が発生しました。カスタマーサポートにお問い合わせください(01)',
    commonError:'異常が発生しました。カスタマーサポートにお問い合わせください',
  },
  settlement_Easy_and_convenient:"安心してお気軽にご加入ください。",
  settlement_Great_deal:"お得な情報",
  settlement_Safe_and_secure:"安全・安心",
  settlement_Autopay_service_regulation:"自動更新のご利用規約",
  settlement_Read:"確認",
  settlement_No_coupon:"利用可能なクーポン/プロモーションコードがありません",
  settlement_Subtotal:"元の価格",
  settlement_Coupon:"クーポン",
  settlement_TOTAL:"実際のお支払金額",
  settlement_promotion_tip:"このイベントオファーはその他クーポンとの併用はできません。",
  settlement_coupon_tip:"このクーポン/プロモーションコードは限定パッケージに適用できません。",
  member_myFlow_noList:"使用可能なデータがありません",
  detail_se_content:"いつでもキャンセルできます。安心してお気軽にご加入ください。",
  Enter_Promo_code:"クーポン/プロモーションコード",
  Enter_Promo_Coupon:"クーポン",
  settlement_Not_used_coupon:"クーポンは使用されていません",
  settlement_Available_coupon:"利用可能",
  settlement_Unavailable_coupon:"利用できません",
  please_Enter_Promo_code:"クーポン/プロモーションコードを入力してください",
  please_Select_Coupon_use:　"ご利用になりたいクーポンを選択してください。",
  Buy_Now:"すぐに購入",
  Dont_Use_Any:"使用しない",
  flowDetail_unsubscribe: "キャンセル",
  flowDetail_unsubscribed: "キャンセル済み",
  flowDetail_isCancelPackage: "キャンセルしますか？",
  flowDetail_confirmAgreementUnsubscribe : "自動更新のキャンセル後、専属特典が無効になりますので、キャンセルをご確認のほどよろしくお願いいたします。",
  flowDetail_cancel: "キャンセル",
  flowDetail_cancelSuccess: "キャンセルされました",
  packages_detail_promotion:"イベント",
  orderTips:{
        "iDay" : "日間",
        "iDays" : "日間",
        "iMonth" : "月",
        "iMonths" : "か月",
        'First_charge_discount':"初回更新費用は<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol 。次月以降毎月 %@money/%@periodSymbol, で自動更新されます。いつでもキャンセルできます",
        'Monthly_discount':"毎月 %@saveMoney/%@periodを節約できます！いつでもキャンセル可能です",
        'Ordinary_monthly_package':"いつでもキャンセルできます。安心してお気軽にご加入ください。",
        "AlreadyPurchased":'大変申し訳ございませんが、1ユーザーが同時にご利用可能な自動更新割引サービスは1つのみです。 「%@」の自動更新をオフにし、満了後に他の自動更新サービスを有効にしてください。',
        "Contract_recommendation_First":'<label>自動更新を起用します。初回更新費用はです</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">いつでもキャンセルできます'
        +'<a class="btn">起用 ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>自動更新を起用します。毎月の更新費用はです</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">いつでもキャンセルできます'
        +'<a class="btn">起用 ></a></p>',
        "Contract_recommendation_General":"<label>自動更新を起用します。</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">いつでもキャンセルできます。安心してお気軽にご加入ください。'
        +'<a href="javascript:;" class="btn">起用 ></a></p>',
        'BanlanceDoubleCheck':'残額を利用してお支払いしますか？',
    },
    feedback: {
      title: "フィードバック",
      placeholder: "訪問したい国やその他の質問を入力してください。できるだけ早くお客様のニーズを満たしています。",
      submit: "提出する",
      submit_success: "送信に成功しました",
      other_opinions: "その他のご意見",
    },
    view_country_input: 'アカウントを入力してください',
    select_package: {
      title: 'データを選択',
      allPackage: 'すべてのデータ',
      type: 'タイプ',
      flow: 'データ',
      month_package: '月額プラン',
      flow_package: 'データパッケージ',
      time: '利用時間',
      period: 'サイクル',
      auto_debit: '自動引き落とし案内',
      auto_subscribe: '自動更新',
      detail: 'データ詳細',
      carrier: '対応キャリア',
      country: '対象国一覧',
      notice: '購入ガイドライン'
    },
}